import { CustomerState } from "../customer.slice.ts";
import { PayloadAction } from "@reduxjs/toolkit";
import { SubmitContactsPayload } from "../../../actions/submit-contacts.action.ts";

export const submitContactsReducer = (
  state: CustomerState,
  action: PayloadAction<SubmitContactsPayload>,
) => {
  state.contacts = action.payload.contacts;
};
